export default function TableBottomControls({
  currentPage,
  totalPages,
  setCurrentPage,
  startItem,
  endItem,
  totalItems
}) {

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    let start = Math.max(1, currentPage - 2);
    let end = Math.min(totalPages, start + maxVisible - 1);

    if (end - start < maxVisible - 1) {
      start = Math.max(1, end - maxVisible + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  return (
    <div className="flex items-center justify-between flex-wrap gap-3 p-4 border-t border-slate-200">

      {/* 📊 Showing text */}
      <div className="text-sm text-slate-600">
        {totalItems === 0
          ? "No records to show"
          : `Showing ${startItem} - ${endItem} of ${totalItems} record${totalItems > 1 ? "s" : ""}`}
      </div>

      {/* 📄 Pagination */}
      <div className="flex items-center gap-1">

        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(currentPage - 1)}
          className="px-3 py-1 border disabled:opacity-50"
        >
          Prev
        </button>

        {getPageNumbers().map((page) => (
          <button
            key={page}
            onClick={() => setCurrentPage(page)}
            className={`px-3 py-1 border ${
              currentPage === page ? "bg-brand-accent text-white" : ""
            }`}
          >
            {page}
          </button>
        ))}

        <button
          disabled={currentPage === totalPages || totalPages === 0}
          onClick={() => setCurrentPage(currentPage + 1)}
          className="px-3 py-1 border disabled:opacity-50"
        >
          Next
        </button>

      </div>
    </div>
  );
}